import * as Sentry from '@sentry/react';

export function initSentry() {
  // Only initialize Sentry in production
  if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.1, // Capture 10% of transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // Sample 10% of sessions
      replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
      // Release tracking
      release: import.meta.env.VITE_APP_VERSION || 'development',
      beforeSend(event) {
        // Filter out non-error events in development
        if (import.meta.env.DEV && event.level !== 'error') {
          return null;
        }
        return event;
      },
    });
  } else if (import.meta.env.DEV) {
    console.info('Sentry disabled in development mode');
  }
}

// Helper to manually capture errors
export function captureError(error: Error, context?: Record<string, any>) {
  console.error('Captured error:', error, context);
  Sentry.captureException(error, {
    extra: context,
  });
}

// Helper to set user context
export function setUserContext(userId: string, email?: string) {
  Sentry.setUser({
    id: userId,
    email,
  });
}

// Helper to clear user context on logout
export function clearUserContext() {
  Sentry.setUser(null);
}
